import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Container,
  Stack,
} from '@mui/material';
import { LocalizedButton as Button, LocalizedChip as Chip } from '../components/i18n/LocalizedMui';
import Typography from '../components/i18n/LocalizedTypography';
import { CheckCircle, Dashboard, WorkspacePremium } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentThankYou: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('paymentId') || '';
  const planType = searchParams.get('planType') || 'premium';

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 5, md: 8 } }}>
      <Card>
        <CardContent sx={{ p: { xs: 3, md: 5 }, textAlign: 'center' }}>
          <CheckCircle sx={{ fontSize: 72, color: 'success.main', mb: 2 }} />
          <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
            Thank you for your payment
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your purchase has been confirmed and activated.
          </Typography>

          <Stack spacing={1.5} alignItems="center" sx={{ mb: 4 }}>
            <Chip
              icon={<WorkspacePremium />}
              label={planType.replace(/_/g, ' ').toUpperCase()}
              color="primary"
            />
            {paymentId && (
              <Typography variant="caption" color="text.secondary" sx={{ wordBreak: 'break-all' }}>
                Payment ID: {paymentId}
              </Typography>
            )}
          </Stack>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Button variant="contained" startIcon={<Dashboard />} onClick={() => navigate('/dashboard')}>
              Go to Dashboard
            </Button>
            <Button variant="outlined" onClick={() => navigate('/pricing')}>
              View Plans
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PaymentThankYou;
